"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = __importDefault(require("../../styles/theme"));
const input_styles_1 = require("./input-styles");
const label_1 = __importDefault(require("../label"));
const icon_1 = require("../icon");
const uplift_icons_1 = require("../uplift-icons");
const text_1 = __importDefault(require("../text"));
const types_1 = require("../../lib/types");
const utils_1 = require("../../lib/utils");
const TextInputContainer = styled_components_1.default.div `
  width: ${(props) => (props.inline ? 'auto' : '100%')};
`;
const StyledInput = styled_components_1.default.input `
  ${input_styles_1.inputStyles}
  width: 100%;
  ${(props) => props.centered && 'text-align: center;'}

  i + & {
    margin-left: 0.3rem;
  }
`;
const StyledInputField = styled_components_1.default.div `
  ${input_styles_1.inputFieldStyles}
  display: flex;
  align-items: center;
  justify-content: space-between;
  input {
    flex: 1;
  }
  &:focus-within {
    outline: ${theme_1.default.outline};
    outline-offset: 1px;
  }
`;
const TextInput = ({ className, style, id, innerRef, type = 'text', inline = false, clearable = false, disabled = false, value = undefined, onChange = utils_1.noop, onBlur = utils_1.noop, onFocus = utils_1.noop, onKeyDown = utils_1.noop, onKeyUp = utils_1.noop, onKeyPress = utils_1.noop, onClick = utils_1.noop, label = undefined, ariaLabel = undefined, placeholder = '', name = '', icon = null, iconPosition = 'left', readOnly = false, centered = false, error = false, maxLength, required, valid = false, step, hint, }) => {
    types_1.accessibleLabelCheck(ariaLabel, label);
    const validStyling = valid
        ? {
            border: `1px ${theme_1.default.colors.iconLogoAccent} solid`,
        }
        : {};
    // The ref is required when this field is "clearable" so that a
    // change event can be dispatched from the <input /> when the Clear
    // button is clicked.
    const internalRef = react_1.useRef(null);
    const resolvedRef = innerRef || (clearable ? internalRef : undefined);
    const clearTextInput = react_1.useCallback(() => {
        var _a;
        const refObj = resolvedRef;
        const inputElement = refObj.current;
        if (inputElement) {
            const prototype = Object.getPrototypeOf(inputElement);
            const prototypeSetter = (_a = Object.getOwnPropertyDescriptor(prototype, 'value')) === null || _a === void 0 ? void 0 : _a.set;
            if (prototypeSetter) {
                prototypeSetter === null || prototypeSetter === void 0 ? void 0 : prototypeSetter.call(inputElement, '');
            }
            inputElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }, [resolvedRef]);
    return (react_1.default.createElement(TextInputContainer, { className: className, "data-testid": "text-input-root", inline: inline, style: style },
        label && react_1.default.createElement(label_1.default, { error: !hint && error }, label),
        react_1.default.createElement(StyledInputField, { disabled: disabled, error: error, style: validStyling },
            iconPosition === 'left' && icon,
            react_1.default.createElement(StyledInput
            // If ariaLabel is not present, then label is a string
            , { "aria-label": ariaLabel || label, "aria-required": required, step: step, id: id, type: type, ref: resolvedRef, name: name, value: value, disabled: disabled, onChange: (event) => onChange(event.target.value, event), onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, onClick: onClick, placeholder: placeholder, readOnly: readOnly, centered: centered, maxLength: maxLength, 
                // NOTE: required here below is just to help with input:valid css
                // selector. It does not actually make field required, that still
                // needs to be done with field validators
                required: required }),
            clearable && !!value && (react_1.default.createElement(icon_1.IconButton, { ariaLabel: "clear", color: theme_1.default.colors.textInput, name: "close", onClick: clearTextInput })),
            iconPosition === 'right' && icon,
            valid && (react_1.default.createElement(uplift_icons_1.IconCheckmark, { size: "20.25px", color: theme_1.default.colors.iconLogoAccent }))),
        hint && (react_1.default.createElement(text_1.default, { fontSize: "xs", fontWeight: "normal", color: error ? theme_1.default.colors.error : theme_1.default.colors.textDefault }, hint))));
};
exports.TextInput = TextInput;
exports.default = exports.TextInput;
